import { render, staticRenderFns } from "./ProjectMappingRuleCreate.vue?vue&type=template&id=00845278&"
import script from "./ProjectMappingRuleCreate.vue?vue&type=script&lang=js&"
export * from "./ProjectMappingRuleCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports